/**
 * AI Chat Entity Schemas
 *
 * Types for AI conversations and messages.
 */

import { z } from 'zod'

/**
 * Conversation Status Schema
 */
export const ConversationStatusSchema = z.enum(['ACTIVE', 'ARCHIVED', 'DELETED'])
export type ConversationStatus = z.infer<typeof ConversationStatusSchema>

/**
 * Message Role Schema
 */
export const MessageRoleSchema = z.enum(['user', 'assistant', 'system'])
export type MessageRole = z.infer<typeof MessageRoleSchema>

/**
 * AI Message Schema
 */
export const AiMessageSchema = z.object({
  id: z.string(),
  role: MessageRoleSchema,
  content: z.string(),
  createdAt: z.string(),
  metadata: z.record(z.string(), z.unknown()).optional()
})

export type AiMessage = z.infer<typeof AiMessageSchema>

/**
 * AI Conversation Schema
 */
export const AiConversationSchema = z.object({
  id: z.string(),
  title: z.string().nullable().optional(),
  status: ConversationStatusSchema,
  userId: z.string(),
  schoolId: z.string().nullable().optional(),
  messages: z.array(AiMessageSchema).optional(),
  messageCount: z.number().optional(),
  lastMessageAt: z.string().nullable().optional(),
  createdAt: z.string(),
  updatedAt: z.string()
})

export type AiConversation = z.infer<typeof AiConversationSchema>
